export enum loginProviders {
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  TEKMAN = 'TEKMAN',
}

export interface AccessTokenVerifier {
  issued_to: string;
  audience: string;
  user_id: string;
  scope: string;
  expires_in: number;
  email: string;
  verified_email: boolean;
  access_type: string;
}

export interface AuthProfile {
  provider?: loginProviders;
  userId?: string;
  email?: string;
  name?: string;
  accessToken: string;
}
export interface SelectedClass {
  id: string;
  name: string;
}

export interface AlreadyImportedClass {
  /** Name of the external class (Google Classroom / Microsoft Teams) */
  name: string;
  /** Id of the ONMAT class it was imported into, only when it is known (the creation API does not return it) */
  groupId?: string;
}

export interface AlreadyImportedClasses {
  provider: loginProviders;
  classes: AlreadyImportedClass[];
}

// ###################################################

// GOOGLE Interfaces
export interface GClassroomCoursesListResponse {
  courses: CourseClassroom[];
}

export interface CourseClassroom {
  id: string;
  name: string;
  section: string;
  descriptionHeading: string;
  room: string;
  ownerId: string;
  creationTime: string;
  updateTime: string;
  enrollmentCode: string;
  courseState: string;
  alternateLink: string;
  teacherGroupEmail: string;
  courseGroupEmail: string;
  teacherFolder: TeacherFolder;
  guardiansEnabled: boolean;
  calendarId: string;
  gradebookSettings: GradebookSettings;
}

export interface GradebookSettings {
  calculationType: string;
  displaySetting: string;
}

export interface TeacherFolder {
  id: string;
  title: string;
  alternateLink: string;
}

export interface UserInfoResponse {
  id: string;
  name: GoogleProfileName;
  emailAddress: string;
  permissions: GoogleProfilePermission[];
}

export interface GoogleProfileName {
  givenName: string;
  familyName: string;
  fullName: string;
}

export interface GoogleProfilePermission {
  permission: string;
}

// ###################################################

export interface TeacherClassroom {
  courseId: string;
  profile: TeacherProfile;
}

export interface TeacherProfile {
  emailAddress: string;
  id: string;
  userId: string;
  name: GoogleProfileName;
}
